import { IconButton, Tooltip } from '@crazyegginc/hatch';

import { ReactComponent as HeatmapsIcon } from '@crazyegginc/hatch/dist/images/icon-heat-filled.svg';
import { SOURCE_TYPE } from '/src/components/source-selector/source-selector';

export function InstantHeatmaps({ selectedSource, path, domain = null }) {
  // Don't show Instant Heatmaps for GA properties for now:
  // https://app.shortcut.com/crazyegg/story/70122/remove-instant-heatmaps-modal-fire-icon-on-ga-properties
  if (selectedSource?.type === SOURCE_TYPE.GA_PROPERTY) return null;

  if (!path || path.includes('*')) return null;

  return (
    <Tooltip tooltipContent={<div className="px-2 py-1 font-semibold text-[14px]">View Instant Heatmap</div>}>
      <IconButton
        icon={<HeatmapsIcon className="h-4 w-4 fill-current" />}
        className="text-california-500 !p-0"
        onClick={() => {
          if (window.HudLauncher?.open) {
            const hostname = domain || selectedSource?.name;
            const normalizedPath = path.startsWith('/') ? path : `/${path}`;
            if (hostname) {
              window.HudLauncher.open(`https://${hostname}${normalizedPath}`, { powerup: true });
            }
          }
        }}
        label="View Instant Heatmap"
      />
    </Tooltip>
  );
}
